import { PublicBaseEventSerializer } from "@shared/modules/events/types/public";
import Script from "next/script";

type EventQueueItProps = {
  event: PublicBaseEventSerializer;
};

export const EventQueueIt: React.FC<EventQueueItProps> = ({ event }) => {
  // if the event is protected by a queue, return queue-it script tags
  // else return nothing
  return event.is_protected_by_queue ? (
    <>
      <Script
        type="text/javascript"
        src="//static.queue-it.net/script/queueclient.min.js"
      />
      <Script
        data-queueit-c="showpass"
        type="text/javascript"
        src="//static.queue-it.net/script/queueconfigloader.min.js"
      />
    </>
  ) : (
    <></>
  );
};

export default EventQueueIt;
